import { FC } from 'react';
import { Link } from 'react-router-dom';

import { List, ListItem, Link as MUILink, Typography } from '@mui/material';

type GatewayDetailProps = {
  title: string;
  details: {
    label: string;
    to?: string;
  }[];
};

const GatewayDetail: FC<GatewayDetailProps> = ({ title, details }) => {
  return (
    <div>
      <Typography variant='body1' sx={{ pb: 1 }}>
        {title}
      </Typography>

      <List sx={{ p: 0 }}>
        {details.map((detail, index) => (
          <ListItem key={index} sx={{ p: 0 }}>
            {detail.to ? (
              <MUILink
                component={Link}
                variant='body2'
                to={detail.to}
                underline='none'
              >
                #{detail.label}
              </MUILink>
            ) : (
              <Typography variant='body2'>{detail.label}</Typography>
            )}
          </ListItem>
        ))}
      </List>
    </div>
  );
};

export default GatewayDetail;
